<template>
  <div
    id="via-modal"
    class="via-modal"
    v-show="isActive"
    @click.self="$emit('on-close')"
  >
    <div class="via-modal-content">
      <div class="via-modal-container">
        <div class="via-modal-header">
          <div class="via-close-x-header" @click.self="$emit('on-close')">
            &#10005;
          </div>
        </div>

        <div class="via-modal-body">
          <div class="via-table">
            <div class="via-table-container">
              <slot />
            </div>
          </div>
        </div>

        <div class="via-modal-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductsPopup',
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
/* Outer modal styles */
.via-modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(3, 3, 3, 0.46);
  font-size: 14px !important;
}

.via-modal-content {
  background-color: #fff;
  position: relative;
  width: 600px;
  box-shadow: 0 3px 10px -2px rgb(85 85 85 / 12%),
    0 2px 20px 0 rgb(85 85 85 / 10%), 0 1px 30px 0 rgb(85 85 85 / 6%);
  animation-name: via-modalopen;
  animation-duration: 0.5s;
  border-radius: 6px;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 8px 20px;
  height: max-content;
  margin: 5px;
}

.via-modal-content a {
  color: unset;
  text-decoration: unset;
}

@keyframes via-modalopen {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* ----------  Table Structure ----------- */
/* Contain */
.via-table {
  color: #2c2c2c;
}

.via-table div,
.via-table a {
  box-sizing: border-box;
}

.via-table-container {
  display: grid;
  max-width: 600px;
  font-size: 14px;
}

.via-modal-footer {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 4px;
}
/* 
.via-brand a {
} */

.via-brand {
  float: left;
}

.via-closeBtn {
  background: none;
  font-size: 14px;
}

.closeBtn:focus,
.via-closeBtn:hover {
  text-decoration: none;
  cursor: pointer;
}

@media all and (max-width: 550px) {
  .via-modal-content {
    padding: 5px 10px;
  }
}

/* option one close x header */

.via-close-x-header {
  padding: 5px;
  background-color: white;
  box-shadow: 0 3px 10px -2px rgb(85 85 85 / 8%),
    0 2px 20px 0 rgb(85 85 85 / 6%), 0 1px 30px 0 rgb(85 85 85 / 3%);
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;

  /* For padding via-modal-content and own width and height */
  transform: translate(calc(8px + 20px), -8px);
}

@media all and (max-width: 650px) {
  .via-close-x-header {
    /* Add close button inside widget */
    transform: translate(8px, 8px);
  }
}

.via-close-x-header:hover {
  cursor: pointer;
}

.via-modal-header {
  float: center;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 0;
}
</style>
